import React, { useState } from 'react';
import { Button, PopUp } from 'cantarus-react-ui';
import DNNAssetManager from 'cantarus-dnn-asset-manager';
import { AssetManagerPopUpStrings as Strings } from '../../utils/config';

const AssetManagerPopUp = ({ show, togglePopUp, handleAssetChange }) => {
    const [urlToSave, setUrlToSave] = useState('');

    const handleSelect = (assets) => {
        if (assets) {
            let asset = assets[0];
            if (typeof asset !== 'undefined'
                && typeof asset.AssetUrl !== 'undefined') {
                setUrlToSave(asset.AssetUrl);
            }
        }
    }

    const handleClose = () => {
        setUrlToSave('');
        togglePopUp();
    }

    const handleSave = () => {
        handleAssetChange(urlToSave);
        handleClose();
    }

    return (
        <PopUp
            title={Strings.title}
            show={show}
            width="60%"
            togglePopUp={handleClose}
            classes='asset-manager'
        >
            <DNNAssetManager onSelectAssets={handleSelect} />
            <hr />
            <div>
                <Button classes={['secondary']} text={Strings.cancelButton} onClick={handleClose} />
                {urlToSave && <Button text={Strings.saveButton} onClick={handleSave} />}
            </div>
        </PopUp>
    )
}

export default AssetManagerPopUp;
